/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
/* eslint-disable import/no-unresolved */
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

export default () => {
  const heroSlider = document.querySelector('.js-hero-slider');
  if (heroSlider) {
    new Swiper('.js-hero-slider .swiper', {
      autoHeight: false,
      loop: false,
      autoplay: heroSlider && heroSlider.dataset.autoplay ? {
        delay: parseInt(heroSlider.dataset.autoplay, 10),
      } : false,
      spaceBetween: 15,
      slidesPerView: 1,
      navigation: {
        prevEl: '.js-hero-slider .ctrl--prev',
        nextEl: '.js-hero-slider .ctrl--next',
      },
      pagination: {
        el: '.js-hero-slider .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  }

  document.querySelectorAll('.js-logoslider').forEach((elem) => {
    new Swiper(elem.querySelector('.swiper'), {
      autoHeight: false,
      loop: false,
      autoplay: elem.dataset.autoplay ? {
        delay: parseInt(elem.dataset.autoplay, 10),
      } : false,
      spaceBetween: 20,
      slidesPerView: 2,
      navigation: {
        prevEl: elem.querySelector('.ctrl--prev'),
        nextEl: elem.querySelector('.ctrl--next'),
      },
      pagination: false,
      breakpoints: {
        650: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 5,
        },
      },
    });
  });

  /**
   * Слайдер сертификатов на стр. бренда
   */
  document.querySelectorAll('.js-sertifslider').forEach((elem) => {
    new Swiper(elem.querySelector('.swiper'), {
      autoHeight: false,
      loop: false,
      autoplay: elem.dataset.autoplay ? {
        delay: parseInt(elem.dataset.autoplay, 10),
      } : false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      navigation: {
        prevEl: elem.querySelector('.ctrl--prev'),
        nextEl: elem.querySelector('.ctrl--next'),
      },
      pagination: false,
      breakpoints: {
        650: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
        },
      },
    });
  });

  /**
   * Слайдер товаров на стр бренда.
  */
  document.querySelectorAll('.js-product-slider').forEach((elem) => {
    new Swiper(elem.querySelector('.swiper'), {
      autoHeight: false,
      loop: false,
      autoplay: elem.dataset.autoplay ? {
        delay: parseInt(elem.dataset.autoplay, 10),
      } : false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      navigation: {
        prevEl: elem.querySelector('.ctrl--prev'),
        nextEl: elem.querySelector('.ctrl--next'),
      },
      pagination: false,
      breakpoints: {
        650: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: 4,
        },
      },
    });
  });

  /**
   * Слайдер "вы уже смотрели" в каталоге.
  */
  window.initHistoryProductSlider = () => {
    document.querySelectorAll('.js-history-slider').forEach((elem) => {
      if (elem.swInstance) {
        console.log('Слайдер уже был инициализирован. Производится обновление конфигурации');
        elem.swInstance.update();
        return;
      }
      elem.swInstance = new Swiper(elem.querySelector('.swiper'), {
        autoHeight: false,
        loop: false,
        autoplay: elem.dataset.autoplay ? {
          delay: parseInt(elem.dataset.autoplay, 10),
        } : false,
        spaceBetween: 10,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        navigation: {
          prevEl: elem.querySelector('.ctrl--prev'),
          nextEl: elem.querySelector('.ctrl--next'),
        },
        pagination: false,
        breakpoints: {
          650: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        },
      });
    });
  };
  window.initHistoryProductSlider();
};
